import { router, setPageContent } from "..";
import { signIn } from "../api/sign-in";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox, passwordInput } from "../view/components";

function signInPage() {
	const email = Bulma.input({
		type: "email",
	});

	const password = passwordInput();

	const onClickSignIn = () => {
		const attempt = errorSection.attempt(async () => {
			await signIn(email.getValue(), password.getValue());
			await state.refreshDevices();
			const user = await state.getSignedInUser();

			if (user.AccountType === "smartplug2-factory") {
				router.jump("/factory/smartplug2");
			} else {
				router.jump("/devices");
			}
		});
		loadingScreen.waitFor(attempt);
	};

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(t.signIn),
			Bulma.field(
				{},
				Bulma.label(t.email),
				Bulma.control({}, email.element),
			),
			Bulma.field({}, Bulma.label(t.password), password.element),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickSignIn,
						styles: ["is-fullwidth", "is-primary"],
					},
					t.signIn,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/create-account"),
						styles: ["is-fullwidth", "is-primary", "is-small"],
					},
					t.createAccount,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/reset-password"),
						styles: ["is-fullwidth", "is-primary", "is-small"],
					},
					t.resetPassword,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/verify-account"),
						styles: ["is-fullwidth", "is-primary", "is-small"],
					},
					t.verifyAccount,
				),
			),
		),
	);
}

export { signInPage };
